import { TModal, TButton, TInput } from "vue-tailwind/dist/components";

const settings = {
    "t-modal": {
        component: TModal,
        props: {
            fixedClasses: {
                overlay:
                    "modal z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black/10 flex justify-center",
                wrapper:
                    "z-50 relative my-6 lg:my-12 flex justify-center w-2/3 md:w-1/2 py-6",
                modal: "bg-white shadow relative",
                body: "p-4 bg-white  h-5/6 overflow-y-auto ",
                header: "p-4 border-b text-sm font-semibold uppercase text-gray-700 bg-gray-100",
                footer: "p-2 border-t",
                close: "absolute right-0 top-0 m-3 text-gray-700 hover:text-gray-600 transition duration-1000 ",
                closeIcon: "h-5 w-5 fill-current",
            },
            classes: {
                overlay: "",
                wrapper: "",
                modal: "",
                body: "p-4",
                header: "text-gray-700",
                footer: "",
                close: "text-gray-700 hover:text-gray-600",
                closeIcon: "",
            },
            variants: {
                danger: {
                    overlay: "bg-red-500",
                    header: "border-red-100 text-red-700",
                    footer: "border-red-100 bg-red-100",
                    close: "text-red-700 hover:text-red-600",
                },
            },
        },
    },
    "t-button": {
        component: TButton,
        props: {
            classes: "",
            variants: {
                primaryCreate: "primary btn-create",
                secondaryCreate: "secondary btn-create",
                secondaryMaterial: "secondary material btn-misc",
                tertiaryCreate: "tertiary btn-create",
                primaryUpdate: "primary btn-update",
                secondaryUpdate: "secondary btn-update",
                tertiaryUpdate: "tertiary btn-update",
                primaryInfo: "primary btn-info",
                secondaryInfo: "secondary btn-info",
                tertiaryInfo: "tertiary btn-info",
            },
            // Optional fixedClasses
            fixedClasses: "btn",
        },
    },
    "t-input": {
        component: TInput,
        props: {
            classes: "bg-white ",
            // Optional variants
            variants: {
                feature: "text-red-500",
            },
            // Optional fixedClasses
            fixedClasses: "form-input",
        },
    },
};

export default settings;
